import { useNavigate } from "react-router-dom";
import { UnitCardProps } from "./UnitCard.interface";
import { routes } from "../../shared/router/routes";
import { getFromattedPath } from "../../shared/helpers/utils";
import { useCallback, useContext } from "react";
import { AnalyticsContext } from "../../shared/providers/analytics/analytics.provider";
import { UserContext } from "../../shared/providers/user/user.provider";

function UnitCard({ unit, index, moduleId, moduleImage, fromUnit }: UnitCardProps) {
    const navigate = useNavigate();
    const { setEvent } = useContext(AnalyticsContext);
    const { user } = useContext(UserContext);

    const navigateUnit = useCallback(() => {

        if(fromUnit) setEvent({
            event_category: "content_navigation",
            event_action: "app_unit_unit",
            user_token: user?.id,
            unit_id: unit.id
        });
        
        const path = getFromattedPath(routes.UNIT.path, { moduleId, unitId: unit.id });
        navigate(path);

    }, [moduleId, unit]);

    return (
        <button type="button" className="card card_unit d-flex gap-1 p-02 pe-1 w-100" onClick={navigateUnit}>
            <figure className="unit_thumbnail" data-index={index}>
                <img src={moduleImage} alt={unit.title} />
            </figure>
            <div className="w-100 d-flex flex-column gap-02">
                <div className="d-flex justify-content-between">
                    <span
                        className={`color-${unit?.tag_color ?? "yellow"}-500 text-bd4-bd text-uppercase`}>
                        {unit.tag}
                    </span>
                    {unit.isCompleted && (
                        <i className="icon icon-24 icon-Checkmark--filled color-green-500" />
                    )}
                </div>
                <h2 className="lineclamp-1 text-bd2-bd color-neutrals-black text-start">{unit.title}</h2>
            </div>
        </button>
    );
}

export default UnitCard;
